import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import React from 'react';
import { useSelector } from 'react-redux';
import { ROUTE_GOVCRM_CONTACTS, ROUTE_MY_PURSUITS, ROUTE_VENDORS_MANAGEMENT } from '../../../../constants/routes';
import { useMediaQueryDown } from '../../../../hooks/useMediaQuery';
import { canShowCrmNav, useSubscriptionPermission } from '../../../../hooks/useSubscriptionPermission';
import { useTrans } from '../../../../services/i18n';
import SpacingContainer from '../../../common/Containers/Base/SpacingContainer';
import { RouterLink } from '../../../common/Buttons';
import Typography from '../../../common/Typography';
import { IconPursuits } from '../../../svg';
import { IconOverview, IconVendors } from '../../../svg/Icons/Menu';

const HeaderQuickNav = () => {
  const { trans } = useTrans();
  const isExtraSmallScreen = useMediaQueryDown('xs');
  const crmAccessEnabled = useSelector((state) => state.orgSettings.crmAccessEnabled === true);
  const { permissions, hasPermission: hasVendorManagement } = useSubscriptionPermission('vendor-management-visibility');
  const { hasPermission: hasPursuits } = useSubscriptionPermission('my-pursuits-visibility');
  const showCrmNav = canShowCrmNav(crmAccessEnabled, permissions);

  const iconButtonStyle = {
    padding: isExtraSmallScreen ? 6 : 12,
    color: '#4E5978',
  };

  if (!showCrmNav && !hasVendorManagement && !hasPursuits) {
    return null;
  }

  return (
    <SpacingContainer
      px={isExtraSmallScreen ? 0 : 1}
      py={0}
      style={{ display: 'flex', alignItems: 'center', flexWrap: 'nowrap' }}
    >
      {showCrmNav && (
        <Tooltip title={<Typography variant="body2">CRM</Typography>}>
          <IconButton
            aria-label="CRM"
            disableRipple
            color="inherit"
            component={RouterLink}
            to={ROUTE_GOVCRM_CONTACTS.path}
            style={iconButtonStyle}
          >
            <IconOverview />
          </IconButton>
        </Tooltip>
      )}
      {hasVendorManagement && (
        <Tooltip title={<Typography variant="body2">{trans('vendor-management')}</Typography>}>
          <IconButton
            aria-label={trans('vendor-management')}
            disableRipple
            color="inherit"
            component={RouterLink}
            to={ROUTE_VENDORS_MANAGEMENT.path}
            style={iconButtonStyle}
          >
            <IconVendors />
          </IconButton>
        </Tooltip>
      )}
      {hasPursuits && (
        <Tooltip title={<Typography variant="body2">Pursuits</Typography>}>
          <IconButton
            aria-label="Pursuits"
            disableRipple
            color="inherit"
            component={RouterLink}
            to={ROUTE_MY_PURSUITS.path}
            style={iconButtonStyle}
          >
            <IconPursuits />
          </IconButton>
        </Tooltip>
      )}
    </SpacingContainer>
  );
};

export default HeaderQuickNav;
